export const separateStringWithDots = (string) => {
  let arr = string?.split('.');
  let fixedArray = [];

  for (let i = 0; i < arr.length; i++) {
    // Regex para detectar strings de 2 a 4 letras
    const isExtension = /^[A-Za-z]{2,4}$/.test(arr[i]);

    if (isExtension && fixedArray.length > 0 && fixedArray[fixedArray.length - 1].includes('@')) {
      // Concatenamos '.extensión' al elemento anterior si es parte de un email
      fixedArray[fixedArray.length - 1] += `.${arr[i]}`;
    } else {
      fixedArray.push(arr[i]);
    }
  }

  return fixedArray;
}